<template>
  <div class="signIn" style="background: rgb(245, 245, 248);">
    <!--    <div class="home_tit" style="background-color: #fff;">-->
    <!--      <div class="home_tit_top" style="background:#fff;padding:0 12px;">-->
    <!--        <div-->
    <!--          style="display: flex;align-items: center;justify-content: space-between;padding: 10px 0;"-->
    <!--        >-->
    <!--          &lt;!&ndash; <div style="font-size: 16px; font-weight: bold;">发现</div> &ndash;&gt;-->
    <!--          <div-->
    <!--            class="iconfont icon-jiantou_liebiaoxiangzuo_o"-->
    <!--            style="font-size: 30px; color: #333;height: 40px;width: 40px;"-->
    <!--            @click="onClickLeft"-->
    <!--          ></div>-->
    <!--          <div-->
    <!--            style="flex:1;border:1px solid #dfdfdf;display:flex;align-items:center;background:#f2f2f2;height: 30px;border-radius:5px;padding:0 10px;"-->
    <!--          >-->
    <!--            <img-->
    <!--              src="../../assets/images/new/sou.png"-->
    <!--              style="width: 16px;height: 16px;margin-right:4px"-->
    <!--              alt=""-->
    <!--            />-->
    <!--            <input-->
    <!--              type="text"-->
    <!--              style="font-size:13px;background-color: f2f2f2;"-->
    <!--              :placeholder="$t('m.fx_span1')"-->
    <!--            />-->
    <!--          </div>-->
    <!--          <div class="home_tit_right">-->
    <!--            <img @click="goTo(112)" src="../../assets/images/new/kefu1.png" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        &lt;!&ndash; <div style="flex:1;border:1px solid #dfdfdf;display:flex;align-items:center;background:#f2f2f2;height: 30px;border-radius:5px;padding:0 10px;margin-top: 20px;">-->
    <!--				<img src="../../assets/images/new/sou.png" style="width: 16px;height: 16px;margin-right:4px" alt="" />-->
    <!--				<input type="text" style="font-size:13px;background-color: f2f2f2;" :placeholder="$t('m.fx_span1')" />-->
    <!--			</div> &ndash;&gt;-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="content">
      <van-nav-bar
        :title="$t('m.list3')[0]"
        fixed
        placeholder
        :border="false"
        left-arrow
        @click-left="onClickLeft"
      />
      <div style="padding:0 10px;">
        <div class="signIn_btn" style="position: relative;">
          <!-- <div v-if="pid!=0" style=" position: absolute;top:-40px;right:0;font-size:10px;color:#fff;"> <span style="width: 80px;
		   display: inline-block;line-height:30px;border-radius:6px;text-align:center;background:#f83051;color:#fff;font-size:13px;" @click="dianji(pid)">上级会员</span> </div> -->
          <!-- <div class="discolor" style="display:flex;height: 45px;">
            <img style="position: relative;top:-25px; width: 70px;height: 70px;border-radius:35px;border:4px solid #fff;" src="../../assets/images/new/user-list.png" alt="" />
            <span style="margin-left:12px;font-weight:bold;font-size:16px;margin-top:10px;" >{{ userInfo.username }}</span>
          </div> -->
          <div
            style="display:grid;padding:20px;grid-template-columns:1fr 1fr;grid-row-gap:20px"
          >
            <div style="text-align:center;flex:1;">
              <p style="font-size:20px;color:var(--bg-color);font-weight:blod;">
                {{ tongji.yishou }}
              </p>
              <p style="font-size:12px;margin-bottom:4px;">
                {{ $t("m.jy_span10") }}
              </p>
            </div>
            <div style="text-align:center;flex:1;">
              <p style="font-size:20px;color:var(--bg-color);font-weight:blod;">
                {{ tongji.daishou }}
              </p>
              <p style="font-size:12px;margin-bottom:4px;">
                {{ $t("m.jy_span11") }}
              </p>
            </div>
          </div>

          <!-- <div style="display:flex;align-items:center;height: 50px;">
            <div
              style="display:flex;align-items:center;justify-content: center;font-size:13px;flex:1;"
            >
              <img
                style="width: 14px;height: 14px;margin-right:3px;"
                src="../../assets/images/yhk/viptd.png"
                alt=""
              />
              <div>
                总收益:<span style="color: red;">{{
                  userInfo.tadditional
                }}</span
                >元
              </div>
            </div>
            <div style="width: 1px;height: 20px;background:#eee;"></div>
            <div
              style="display:flex;align-items:center;justify-content: center;font-size:13px;flex:1;"
            >
              <img
                style="width: 14px;height: 14px;margin-right:3px;"
                src="../../assets/images/yhk/vip.png"
                alt=""
              />
              <div>会员等级：{{ userInfo.level }}</div>
            </div>
          </div> -->
        </div>
      </div>
      <div
        style="font-size:15px;font-weight:bold; display:flex;align-items:center; height:50px; color:#333;padding:0 15px;"
      >
        <img
          src="@/assets/images/new/mingxi.png"
          style="width: 20px;height: 20px;margin-right:5px;"
          alt=""
        />
        {{ $t("m.cw_span4") }}
      </div>
      <!-- 签到列表 -->
      <div class="signIn_list">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('m.gengduo')"
          @load="onLoad()"
        >
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="item-box">
              <p>{{ item.title }}</p>
              <p>订单号：{{ item.id }}</p>
              <p>返利时间：{{ item.time }}</p>
            </div>
            <div
              class="item-box"
              style="color: var(--bg-color);text-align: center;"
            >
              <p>{{ item.profit }}</p>
              <p>{{ type[item.atype] }}</p>
              <p>{{ item.status == "0" ? "待返利" : "已完成" }}</p>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div style="height: 1rem;"></div>
  </div>
</template>

<script>
import { getMyUserInfo } from "@api/user";
import request from "@utils/request";

export default {
  name: "",
  data() {
    return {
      userInfo: {},
      imgs: [],
      imgs1: [],
      tongji: {},
      type: {
        "18": "利息",
        "10": "本金",
        "25": "收益"
      },
      list: [],
      signInList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      ids: "",
      upids: "",
      pid: ""
    };
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  created() {
    let that = this;
    setTimeout(() => {
      getMyUserInfo().then(res => {
        console.log(res.data, "oooooo");
        that.userInfo = res.data.data;
      });
    }, 1000);
  },

  methods: {
    dianji(e) {
      this.page = 0;
      this.upids = this.ids = e;
      this.signInList = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      this.loading = false;
      this.onLoad();
    },

    async onLoad() {
      let _this = this;
      request
        .post("/fund/log/project-log", { page: this.page }, { login: true })
        .then(res => {
          this.page = this.page + 1;
          console.log("-------------------------请求数据", this.refreshing);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          _this.tongji = res.data.data.tongji;

          for (var i = 0; i < res.data.data.list.length; i++) {
            _this.list.push(res.data.data.list[i]);
          }
          // _this.list = res.data.data.list
          this.refreshing = false;
          this.loading = false;
          if (res.data.data.list.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log("---------------------请求错误数据，", err);
        });
      // request.post(
      //     "/user/team/team",
      //     { page: _this.page, uid: _this.ids },
      //     { login: true }
      //   )
      //   .then(res => {
      //     console.log("余额宝列表数据");
      //     console.log(res);
      //     if (this.refreshing) {
      //       this.list = [];
      //       this.refreshing = false;
      //     }
      //     this.pid = res.data.data.pid;
      //     for (var i = 0; i < res.data.data.users.length; i++) {
      //       this.signInList.push(res.data.data.users[i]);
      //     }
      //     this.loading = false;
      //     if (res.data.data.users.length < 10) {
      //       this.finished = true;
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //     this.$dialog.error(err.response.data.msg);
      //   });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
html,
body {
  background: #fff !important;
}

.discolor:active {
  opacity: 0.3 !important;
}

.signIn /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}

.signIn /deep/ .van-nav-bar__title {
  color: #fff;
}

.signIn /deep/ .van-icon {
  color: #fff;
}

.signIn {
  .content {
    font-weight: bold;
    color: #000;
    //margin-top: 20px;
    //padding: 0 12px;
    background-image: url(../../assets/images/bg/5.png);
    background-repeat: no-repeat;
    background-size: 100% 175px;
    padding-top: 20px;

    .signIn_title {
      margin: 25px 0;
    }

    .signIn_btn {
      background: #fff;
      box-shadow: 0px 0px 6px #eaeaea;
      border-radius: 10px;
    }

    .sigIn_list_title {
      margin: 20px 0 5px;
    }

    .signIn_list {
      padding: 0 15px;
      .item {
        display: flex;
        padding: 18px 15px 18px 15px;
        justify-content: space-between;
        margin-bottom: 10px;
        border-radius: 8px;
        background-color: #fff;
        .item-box {
          //font-weight: initial;
          font-size: 13px;
        }
      }
    }

    .finish_text {
      padding: 10px 0;
      font-size: 12px;
      color: #666;
      text-align: center;
    }
  }
}

.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  // height: 50px;

  // display: flex;
  // align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  width: 70px;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  padding-right: 0;
  margin: 0 0px;
  color: #333;
  font-weight: bold;
  font-size: 22px;
}

.home_tit_middle img {
  width: 15px;
  height: 15px;
  margin-left: 7px;
}

.home_tit_right {
  padding-right: 0px;

  width: 30px;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 10px;
}
</style>
